import { localStorage } from '@/utils/localStorage'
import _ from 'lodash'

/** @description 根据key保存设置
 * @param key 模块名字
 * @param obj 用户保存的设置
*/
const saveOptionsForKey = (key, obj) => {
  const options = _.assign(localStorage.get('userOptions'), {
    [key]: [obj]
  })
  localStorage.set('userOptions', JSON.stringify(options))
}

/** @description 合并或者覆盖用户设置
 * @param objValue 被合并对象
 * @param srcValue 合并对象
*/
const customizer = (objValue, srcValue) => {
  // 如果srcValue是数组或普通值，则直接覆盖
  if (_.isArray(objValue)) {
    return srcValue;
  }
  // 如果srcValue是对象，则继续合并
  if (_.isObject(objValue) && _.isObject(srcValue)) {
    return _.mergeWith({}, objValue, srcValue, customizer);
  }
  // 否则直接用srcValue覆盖objValue
  return srcValue;
}

/** @description 覆盖用户设置
 * @param index 用户设置索引
 * @param key 模块名字
 * @param obj 用户设置
*/
const overrideOptions = (index, key, obj) => {
  const options = localStorage.get('userOptions');
  const _obj = _.mergeWith({}, options[key][index], obj, customizer);
  options[key][index] = _obj;
  localStorage.set('userOptions', JSON.stringify(options))
}

/** @description 根据id追加用户设置
 * @param key 模块名字
 * @param obj 用户设置
*/
const appendOptions = (key, obj) => {
  const options = localStorage.get('userOptions')
  options[key] = [...options[key], obj]
  localStorage.set('userOptions', JSON.stringify(options))
}

/** @description 根据cinemaId保存filter设置
 * @param obj 需要添加的对象
 * @param key localStorage类别的key
 */
export const saveFilterOptions = (obj, key) => {
  // 判断已存在的options的是否有相同的cinemaId
  // 有 覆盖 没有 追加
  const options = localStorage.get('userOptions')
  // example
  /**
   * {
   *  movie: [{ id: '123', options: {}, }],
   *  box-office-daily: [{ id: '123', options: [], }]
   * }
   */
  if (options && _.has(options, key)) {
    const _index = options[key].findIndex(item => item.id === obj.id)
    const isExist = _index > -1

    console.log(isExist)

    if (isExist) {
      overrideOptions(_index, key, obj)
    } else {
      appendOptions(key, obj)
    }
  } else {
    saveOptionsForKey(key, obj)
  }
}

/** @description 根据id追加options的类别
 * @param obj 需要添加的对象
 * @param key localStorage类别的key
 * @param id user id
 * @param typeKey 追加类别key
 */
export const assignOptions = (obj, key, id, typeKey) => {
  const options = localStorage.get('userOptions');
  const index = options[key].findIndex(item => item.id === id)
  console.log('assign!!!')
  if (index > -1) {
    
  } else {
    saveOptionsForKey({
      id,
      options: {
        [typeKey]: obj,
      }
    })
  }
  localStorage.set('userOptions', options)
}


